module.exports = __webpack_public_path__ + "images/favicon-16.6281ea3b97c8adc2ff677f090ef5940e.png";